import Home from '@/views/Home.vue'
import Enroll from '@/views/Enroll.vue'
import Conversation from '@/views/Conversation.vue'
import ManageEnrollment from '@/views/ManageEnrollment.vue'
import Lab from '@/views/Lab.vue'
import {useCatchAllCheck} from '@/composables/use-catch-all-check.js'
import {useEnv} from '@/composables/use-env.js'

//Routes
export const routes = [

  //Home
  {
    name: 'home',
    path: '/',
    component: Home,
  },

  //Enroll
  {
    name: 'enroll',
    path: '/enroll',
    component: Enroll,
  },

  //Manage enrollment
  {
    name: 'manage-enrollment',
    path: '/enrollments/:enrollmentId/details',
    component: ManageEnrollment,
  },

  //Conversation views
  {
    name: 'conversation.enrollment',
    path: '/conversation/enrollment/:enrollmentId',
    component: Conversation,
  },
  {
    name: 'conversation.channel',
    path: '/conversation/channel/:channelId',
    component: Conversation,
  },

  //Lab
  {
    name: 'lab',
    path: '/lab',
    component: Lab,
    beforeEnter: () => {
      const {isProduction, isStaging} = useEnv()
      if (isProduction.value || isStaging.value) {
        return {name: 'home'}
      }
    },
  },

  //Catch-all redirect
  {
    name: 'catch-all',
    path: '/:pathMatch(.*)*',
    beforeEnter: () => {
      const {setCatchAll} = useCatchAllCheck()
      setCatchAll(true)
      return {name: 'home'}
    },
  },
]
